"use strict";
import React from "react";
import {Redirect, useHistory} from "react-router-dom";

import {useStore} from "../hooks/useStore";
import {getStartRoute} from "../utils/getStartRoute";
import {getFirstGrantedPath} from "../constants/pagePermissions";

export const AuthChecker = props => {
    const stores = useStore();
    const history = useHistory();
    const RenderComponent = props.RenderComponent;
    const tempProp = {...props};
    tempProp.RenderComponent = undefined;

    const {role, isLoggedIn, checkRole, isSubAgency, canAccessPath, can} = stores.meStore;
    const isPoolCustomer = stores.meStore.isPoolCustomer;
    const isUatPoolCustomer = checkRole("isUatPoolCustomer");
    const isDedicatedCustomer = stores?.meStore?.isDedicatedCustomer;

    // Login değilse login'e yönlendir
    if (!isLoggedIn) {
        stores.appStore.setBeforeLogin(history.location.pathname + history.location.search);
        return <Redirect to="/login" />;
    }

    // Havuz müşterisi: sadece /musteri
    if (isPoolCustomer || isUatPoolCustomer) {
        if (!history.location.pathname.startsWith("/musteri")) {
            return <Redirect to="/musteri" />;
        }
        return RenderComponent && <RenderComponent {...tempProp} />;
    }

    // dedike müşteri
    if (isDedicatedCustomer && role === "cUser") {
        if (!history.location.pathname.startsWith("/musteri")) {
            return <Redirect to="/musteri" />;
        }
        return RenderComponent && <RenderComponent {...tempProp} />;
    }

    // Rol listesinde olmayan kullanıcı, sayfaya bağlı dinamik yetki politikasına sahipse de girer.
    const hasRoleAccess = !props.roles || props.roles.includes(role);
    const hasPolicyAccess = Boolean(props.permissionKeys?.some(key => can(key)));

    // Alt kullanıcı (Acente Temsilcisi) rolü agency olarak gelir; yalnızca yetkisi verilen sayfalara girer.
    if (
        isLoggedIn &&
        (hasRoleAccess || hasPolicyAccess) &&
        canAccessPath(history.location.pathname)
    ) {
        return RenderComponent && <RenderComponent {...tempProp} />;
    }

    // Alt kullanıcıda agency başlangıç sayfası yetkisiz olabilir; döngüyü önlemek için yetkili
    // ilk sayfaya (yoksa profile) yönlendirilir.
    const startRoute = isSubAgency
        ? getFirstGrantedPath(stores.meStore.auth?.pagePermissions) || "/profile"
        : getStartRoute({
              role,
              isPoolCustomer,
              isUatCustomer: stores?.meStore?.isUatCustomer,
              isDedicatedCustomer
          });
    return <Redirect to={startRoute} />;
};
